/**
 * Beste verfügbare Bild-URL aus API-Bildobjekt.
 */
export function getImageUrl(imageObject, preferredSize = 'large') {
  if (!imageObject) return null;
  if (typeof imageObject === 'string') return imageObject;

  const image = imageObject.image || imageObject;
  if (!image) return null;
  if (typeof image === 'string') return image;

  if (preferredSize && image[preferredSize]) {
    return image[preferredSize];
  }

  return (
    image.large ||
    image.medium ||
    image['800'] ||
    image['400'] ||
    image.original ||
    image.full ||
    image.small ||
    image.thumbnail ||
    image.post ||
    null
  );
}

export function getOriginalImageUrl(imageObject) {
  if (!imageObject) return null;
  const image = imageObject.image || imageObject;
  if (!image || typeof image === 'string') return typeof image === 'string' ? image : null;
  return image.original || image.large || image.full || image.medium || image['800'] || null;
}

/** ID + Preview-Objekt aus Listen-/Detail-Payload. */
export function extractImageRef(raw) {
  if (!raw && raw !== 0) return { id: null, object: null };
  if (typeof raw === 'object') {
    const id = raw.id != null ? Number(raw.id) : null;
    return { id, object: raw.image || raw.id ? raw : null };
  }
  if (typeof raw === 'number' || (typeof raw === 'string' && /^\d+$/.test(String(raw)))) {
    return { id: Number(raw), object: null };
  }
  return { id: null, object: null };
}
